export default "__VITE_ASSET__04b379b4__"